import head from 'lodash/head';
import { ManualKeyValues } from './constants';
export function isOwnerManualsEmpty(props) {
    return !props || !props.labels;
}
export const getEncodedLocationSearch = (locationSearch) => {
    return locationSearch
        ? locationSearch
            .split('&')
            .map((item) => {
            const itemSplitArr = item.split('=');
            if (itemSplitArr.length === 1) {
                return item;
            }
            const paramName = head(itemSplitArr);
            const paramValue = encodeURIComponent(decodeURIComponent(itemSplitArr.at(-1) || ''));
            return `${paramName}=${paramValue}`;
        })
            .join('&')
        : locationSearch;
};
export const generateUniqueManuals = (data) => {
    return data.reduce((acc, item) => {
        item.modelNames.forEach((modelName) => {
            item.languages.forEach((language) => {
                item.years.forEach((year) => {
                    acc.push({
                        cdnUrl: item.cdnUrl,
                        language,
                        modelName,
                        segmentName: item.segmentName,
                        year,
                    });
                });
            });
        });
        return acc;
    }, []);
};
export const getFilterData = (manuals, filterName) => {
    if (filterName === ManualKeyValues.LANGUAGE) {
        return manuals.reduce((acc, item) => {
            if (acc.some((accItem) => item.language.languageCode === accItem?.value)) {
                return acc;
            }
            acc.push({
                value: item.language.languageCode,
                label: item.language.language,
            });
            return acc;
        }, []);
    }
    const filterValues = Array.from(new Set(manuals.map((manual) => manual[filterName])));
    return filterValues.map((item) => {
        return {
            value: item,
            label: item,
        };
    });
};
export const filterManualsArray = (manuals, filterName, currentValue) => {
    return manuals.filter((manual) => {
        if (filterName === 'language') {
            return manual[filterName]?.languageCode === currentValue;
        }
        return manual[filterName] === currentValue;
    });
};
export const getManualPerPage = (data, currentPage, itemsPerPage) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
};
export const convertActiveItemsToNull = (activeItems) => {
    return activeItems.reduce((acc, item) => {
        return {
            ...acc,
            [item]: null,
        };
    }, {});
};
export const convertFiltersToEmptyArr = (filters) => {
    return filters.reduce((acc, item) => {
        return {
            ...acc,
            [item]: [],
        };
    }, {});
};
export const setDefaultActiveItems = (items, value, filterOnChangeCallback) => {
    if (items.some((item) => item.value === value)) {
        filterOnChangeCallback(value);
    }
};
export const sortFiltersByLabel = (filters, isAscendingOrder = true) => {
    return filters.sort((a, b) => {
        const firstLabel = a.label.toLowerCase();
        const secondLabel = b.label.toLowerCase();
        if (firstLabel < secondLabel)
            return isAscendingOrder ? -1 : 1;
        if (firstLabel > secondLabel)
            return isAscendingOrder ? 1 : -1;
        return 0;
    });
};
